module.exports = __webpack_public_path__ + "img/icon-preview.cd689836.svg";